module.exports = __webpack_public_path__ + "img/upload.ee00ac3a.svg";